define.alias("shared/errors/invalid-credentials-error", "settings/errors/invalid-credentials-error");